import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import BirthCertificateListingContent from './BirthCertificateListingContent';
import useDebounce from '../../../../../../common/components/UseDebounce';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import ImageContainer from '../components/ImageContainer';

const form = {
  keyword: '',
};

function BirthCertificateListingContainer({
  match,
  history,
  getBirthCertificateList,
  userManagementList,
  userManagementListPager,
  isLoading,
  removeUserManagement,
  showBirthCertificate,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Birth Certificate Record',
      modalSize: 'modal-xl',
    });
  };

  const handleViewImage = (data, page) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ImageContainer info={data} page={page} />,
      title: 'Birth Certificate',
      modalSize: 'modal-xl',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update User',
      modalSize: 'modal-xl',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this userManagement?',
      () => {
        removeUserManagement(data.id, () => {
          getBirthCertificateList();
          const id = _.get(userManagementList, '0.id');
          history.push(`/user-management/employees/${id}`);
          showBirthCertificate(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  // const handleFilter = (e) => {
  //   e.preventDefault();
  //   getBirthCertificateList({ ...formData });
  // };

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  }

  useEffect(() => {
    getBirthCertificateList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getBirthCertificateList({ q: formData.keyword, sort_by: 'asc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:userManagementId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            setParams={param}
            moduleName="Records"
            getData={getBirthCertificateList}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Records..."
            pathName={`${match.path}/:userManagementId?`}
            listName="Transaction"
            label="Records List"
            renderItem={(item) => {
              const firstName = _.get(item, 'attributes.first_name', " ") || ""
              const lastName = _.get(item, 'attributes.last_name', "") || ""
              const middleName = _.get(item, 'attributes.middle_name', " ") || ""
              const extName = _.get(item, 'attributes.extension_name', " ") || ""

              return (
                <div className="px-3 py-3">
                  <div className="transaction-list-company">
                    {lastName && firstName ? `${lastName}, ` : `${lastName} `}
                    {firstName && middleName ? `${firstName}, ` : `${firstName} `}
                    {middleName && extName ? `${middleName}, ` : `${middleName} `}
                    {extName}
                  </div>
                </div>
              )
            }}
            isLoading={isLoading}
            selected={params.userManagementId}
            data={userManagementList}
            dataPager={userManagementListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:userManagementId?`}
                    render={() => (
                      <BirthCertificateListingContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleViewImage={handleViewImage}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:userManagementId?`}
                  render={() =>
                    !params.userManagementId &&
                    userManagementList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(userManagementList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BirthCertificateListingContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBirthCertificateList: PropTypes.instanceOf(Function).isRequired,
  userManagementList: PropTypes.instanceOf(Array).isRequired,
  userManagementListPager: PropTypes.instanceOf(Object).isRequired,
  removeUserManagement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showBirthCertificate: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  userManagementList: _.get(api, `${c.GET_BIRTH_CERTIFICATE}.list`) || [],
  userManagementListPager: _.get(api, `${c.GET_BIRTH_CERTIFICATE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BIRTH_CERTIFICATE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BirthCertificateListingContainer);
